import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { IconButton } from '@mui/material';
import { EnhancedDataGrid } from 'components/enhanced/data-grid';
import { useIsBottomFromTenantAdmin } from 'shared/permissions/useIsBottomFromTenantAdmin';
import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ProductWarehouseToCostDialog from './ProductWarehouseToCostDialog';
import { ProductWarehouseLinkMode } from './types';
import { productWarehouseService } from '../api/product-warehouse.service';
import { examService } from 'shared/services';
import { ExamsCostsColumns } from './exams-costs';

interface ProductWarehouseExamsProps {
  productWarehouseId: number;
  // isExamPage?: boolean;
}

function ProductWarehouseExams(props: ProductWarehouseExamsProps) {
  const { t } = useTranslation();
  const { productWarehouseId } = props;

  const datagridRefresh = useRef(null);
  const [mode, setMode] = useState<ProductWarehouseLinkMode>('');

  const isTenantAdminBottom = useIsBottomFromTenantAdmin();

  const reloadExams = () => {
    if (datagridRefresh) datagridRefresh.current();
  };

  const getExams = (limit = 0, offset = 0, params: Record<string, unknown> = {}) => {
    return examService.getAllPaginated(limit, offset, {
      ...params,
      product_warehouses: productWarehouseId
    });
  };

  const columns = ExamsCostsColumns(productWarehouseService, productWarehouseId, datagridRefresh);

  return (
    <>
      <b className="text-primary-600">{t('menu.exams')}</b>
      {isTenantAdminBottom && (
        <IconButton color="primary" onClick={() => setMode('exams')}>
          <AddCircleOutlineIcon />
        </IconButton>
      )}
      <b className="text-primary-600">{t('menu.macro-exams')}</b>
      {isTenantAdminBottom && (
        <IconButton color="primary" onClick={() => setMode('macroexams')}>
          <AddCircleOutlineIcon />
        </IconButton>
      )}
      <br />
      <EnhancedDataGrid
        getMethod={getExams}
        service={examService}
        columns={columns}
        refresh={datagridRefresh}
        disableEdit={!isTenantAdminBottom}
        disableExport={true}
        disableDelete={true}
      />
      <br />
      <ProductWarehouseToCostDialog
        productWarehouseId={productWarehouseId}
        mode={mode}
        setMode={setMode}
        callback={reloadExams}
      />
      <br />
    </>
  );
}

export default ProductWarehouseExams;
